import { useMemo } from 'react'
import MuiContainer from '@mui/material/Container'
import { css } from '@mui/system'
import { cx } from '@emotion/css'
import { Root } from './main.styled'
import Head from 'next/head'

const Main = ({
	children,
	beforeContent,
	ignoreBeforeContentSpace,
	afterContent,
	ignoreAfterContentSpace,
	layout,
	containerProps,
	...props
}) => {
	const { cssClass, cssStyle, type: containerType, maxWidthContainer } = layout

	// containerType
	// full-width    	no-gutter 	maxWidth null
	// boxed         	gutter 		maxWidth null
	// contained     	no-gutter 	maxWidth lg
	// contained-boxed  gutter 		maxWidth lg
	const disableGutters = ['full-width', 'contained'].some((type) => new RegExp(`^${type}$`).test(containerType))
	const maxWidth = ['contained', 'contained-boxed'].some((type) => new RegExp(`^${type}$`).test(containerType))
		? maxWidthContainer
		: null

	const cssProp = useMemo(() => css(cssStyle), [cssStyle])

	return (
		<>
			<Head>
				<style
					dangerouslySetInnerHTML={{
						__html: `#__next {height: 100%}`,
					}}
				></style>
			</Head>
			<Root
				component="main"
				className={cx('main-layout', cssClass)}
				ignoreBeforeContentSpace={ignoreBeforeContentSpace || !beforeContent}
				ignoreAfterContentSpace={ignoreAfterContentSpace || !afterContent}
				{...props}
			>
				{beforeContent}
				<MuiContainer
					id="main"
					className={'main-layout-container'}
					disableGutters={disableGutters}
					maxWidth={maxWidth}
					css={cssProp}
					{...containerProps}
				>
					{children}
				</MuiContainer>
				{afterContent}
			</Root>
		</>
	)
}
export default Main
